// extracted by mini-css-extract-plugin
module.exports = {"root":"BackButton_root__X2Pgx","backBtnTxt":"BackButton_backBtnTxt__8kbcy","light":"BackButton_light__2xM2U","dark":"BackButton_dark__EAhEU"};